import React from 'react';
import Home from '../Home';

import Menu from './menu.js';
import Content from './content.js';
import Footer from './footer.js';

export default class Main extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        console.log('Rendering App');
        return (<div>
            <Menu />
            {/* <Content /> */}
            {
                this.props.children?
                <div className="container topOffset">
                    {this.props.children}
                </div>
                :
                <Home/>
            }

            <Footer />
        </div>);
    }
}


// WEBPACK FOOTER //
// ./app/screens/Main/index.js